import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import { store } from "./redux";

import Router from "./components/Router";
import AnonymousURL from "./components/AnonymousURL";
import { initFirebase } from "./firebaseApi";

initFirebase();

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
    <Switch>
      <Route path="/anon/:courseCode" component={AnonymousURL} />
      <Route path="/:user?/" component={Router} />
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
